// src/api/index.js
export default {
  printingQuery: "/app-api/domainNameRedirection/printingQuery", // 假设后端接口路径
};
